__turbopack_context__.v({
  "root": "LightRays-module__QeE5NG__root",
});
